import { render, staticRenderFns } from "./ReviewWritePage.vue?vue&type=template&id=1d06fb6e&scoped=true"
import script from "./ReviewWritePage.vue?vue&type=script&lang=js"
export * from "./ReviewWritePage.vue?vue&type=script&lang=js"
import style0 from "./ReviewWritePage.vue?vue&type=style&index=0&id=1d06fb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d06fb6e",
  null
  
)

export default component.exports